import SearchBand from './search-band';

export default SearchBand;
